import ConstructiveButton from '@/features/common/buttons/ConstructiveButton'
import { logger } from '@/features/orders/logger'
import { useHandleErrorWithToast } from '@/hooks/useHandleErrorWithToast'
import { FC, useState } from 'react'

interface OrderDetailFooterActionButtonProps {
    children: string
    onPress: () => Promise<void>
}

const OrderDetailFooterActionButton: FC<OrderDetailFooterActionButtonProps> = ({
    children,
    onPress,
}) => {
    const [loading, setLoading] = useState(false)

    const handleError = useHandleErrorWithToast(logger)

    const handlePress = async () => {
        try {
            setLoading(true)

            await onPress()
        } catch (e) {
            handleError(e)
        } finally {
            setLoading(false)
        }
    }

    return (
        <ConstructiveButton
            disabled={loading}
            onPress={handlePress}
            style={{ width: '100%', maxWidth: 240, flexShrink: 1 }}
        >
            {children}
        </ConstructiveButton>
    )
}

export default OrderDetailFooterActionButton
